import { createContext } from 'react';
import { CLH_SESSION_ID } from './helpers';
const initialContext = {
    isLoading: true,
    clhSessionId: CLH_SESSION_ID,
};
export const AccessTokenContext = createContext(initialContext);
